var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"logistics_pic"},[_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.img}})]),_vm._v(" "),_c('a',{staticClass:"xybicon",attrs:{"href":"javascript:;"},on:{"click":_vm.hide}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4417c0f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowPic.vue
// module id = null
// module chunks = 